// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/datasync/v1/data_sync.proto" (package "viam.app.datasync.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../google/protobuf/any";
import { Struct } from "../../../google/protobuf/struct";
import { Annotations } from "../../data/v1/data";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * DataCaptureUploadRequest requests to upload the contents and metadata for tabular data.
 *
 * @generated from protobuf message viam.app.datasync.v1.DataCaptureUploadRequest
 */
export interface DataCaptureUploadRequest {
    /**
     * @generated from protobuf field: viam.app.datasync.v1.UploadMetadata metadata = 1;
     */
    metadata?: UploadMetadata;
    /**
     * @generated from protobuf field: repeated viam.app.datasync.v1.SensorData sensor_contents = 2;
     */
    sensorContents: SensorData[];
}
/**
 * DataCaptureUploadResponse returns the file id of the uploaded contents and metadata for tabular data.
 *
 * @generated from protobuf message viam.app.datasync.v1.DataCaptureUploadResponse
 */
export interface DataCaptureUploadResponse {
    /**
     * @generated from protobuf field: string file_id = 1;
     */
    fileId: string;
    /**
     * @generated from protobuf field: string binary_data_id = 2;
     */
    binaryDataId: string;
}
/**
 * FileUploadRequest requests to upload the contents and metadata for binary (image + file) data.
 * The first packet must be the UploadMetadata associated with the binary data.
 *
 * @generated from protobuf message viam.app.datasync.v1.FileUploadRequest
 */
export interface FileUploadRequest {
    /**
     * @generated from protobuf oneof: upload_packet
     */
    uploadPacket: {
        oneofKind: "metadata";
        /**
         * @generated from protobuf field: viam.app.datasync.v1.UploadMetadata metadata = 1;
         */
        metadata: UploadMetadata;
    } | {
        oneofKind: "fileContents";
        /**
         * @generated from protobuf field: viam.app.datasync.v1.FileData file_contents = 2;
         */
        fileContents: FileData;
    } | {
        oneofKind: undefined;
    };
}
/**
 * FileUploadResponse returns the file id of the uploaded contents and metadata for binary (image + file) data.
 *
 * @generated from protobuf message viam.app.datasync.v1.FileUploadResponse
 */
export interface FileUploadResponse {
    /**
     * @deprecated
     * @generated from protobuf field: string file_id = 1 [deprecated = true];
     */
    fileId: string;
    /**
     * @generated from protobuf field: string binary_data_id = 2;
     */
    binaryDataId: string;
}
/**
 * StreamingDataCaptureUploadRequest requests to upload the contents and metadata for streaming binary (image + file) data.
 * The first packet must be the DataCaptureUploadMetadata associated with the data.
 *
 * @generated from protobuf message viam.app.datasync.v1.StreamingDataCaptureUploadRequest
 */
export interface StreamingDataCaptureUploadRequest {
    /**
     * @generated from protobuf oneof: upload_packet
     */
    uploadPacket: {
        oneofKind: "metadata";
        /**
         * @generated from protobuf field: viam.app.datasync.v1.DataCaptureUploadMetadata metadata = 1;
         */
        metadata: DataCaptureUploadMetadata;
    } | {
        oneofKind: "data";
        /**
         * @generated from protobuf field: bytes data = 2;
         */
        data: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * StreamingDataCaptureUploadResponse returns the file id of the uploaded contents and metadata for streaming binary (image + file) data.
 *
 * @generated from protobuf message viam.app.datasync.v1.StreamingDataCaptureUploadResponse
 */
export interface StreamingDataCaptureUploadResponse {
    /**
     * @deprecated
     * @generated from protobuf field: string file_id = 1 [deprecated = true];
     */
    fileId: string;
    /**
     * @generated from protobuf field: string binary_data_id = 2;
     */
    binaryDataId: string;
}
/**
 * SensorMetadata contains the time the sensor data was requested and was
 * received.
 *
 * @generated from protobuf message viam.app.datasync.v1.SensorMetadata
 */
export interface SensorMetadata {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_requested = 1;
     */
    timeRequested?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp time_received = 2;
     */
    timeReceived?: Timestamp;
    /**
     * @deprecated
     * @generated from protobuf field: viam.app.datasync.v1.MimeType mime_type = 3 [deprecated = true];
     */
    mimeType: MimeType;
    /**
     * @generated from protobuf field: viam.app.data.v1.Annotations annotations = 4;
     */
    annotations?: Annotations;
}
/**
 * SensorData contains the contents and metadata for tabular data.
 *
 * @generated from protobuf message viam.app.datasync.v1.SensorData
 */
export interface SensorData {
    /**
     * @generated from protobuf field: viam.app.datasync.v1.SensorMetadata metadata = 1;
     */
    metadata?: SensorMetadata;
    /**
     * @generated from protobuf oneof: data
     */
    data: {
        oneofKind: "struct";
        /**
         * @generated from protobuf field: google.protobuf.Struct struct = 2;
         */
        struct: Struct;
    } | {
        oneofKind: "binary";
        /**
         * @generated from protobuf field: bytes binary = 3;
         */
        binary: Uint8Array;
    } | {
        oneofKind: undefined;
    };
}
/**
 * FileData contains the contents of binary (image + file) data.
 *
 * @generated from protobuf message viam.app.datasync.v1.FileData
 */
export interface FileData {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
/**
 * UploadMetadata contains the metadata for binary (image + file) data.
 *
 * @generated from protobuf message viam.app.datasync.v1.UploadMetadata
 */
export interface UploadMetadata {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * @generated from protobuf field: string component_type = 2;
     */
    componentType: string;
    /**
     * @generated from protobuf field: string component_name = 3;
     */
    componentName: string;
    /**
     * @generated from protobuf field: string method_name = 5;
     */
    methodName: string;
    /**
     * @generated from protobuf field: viam.app.datasync.v1.DataType type = 6;
     */
    type: DataType;
    /**
     * @generated from protobuf field: map<string, google.protobuf.Any> method_parameters = 8;
     */
    methodParameters: {
        [key: string]: Any;
    };
    /**
     * @generated from protobuf field: string file_name = 7;
     */
    fileName: string;
    /**
     * @generated from protobuf field: string file_extension = 9;
     */
    fileExtension: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp file_create_time = 14;
     */
    fileCreateTime?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp file_modify_time = 15;
     */
    fileModifyTime?: Timestamp;
    /**
     * @generated from protobuf field: repeated string tags = 10;
     */
    tags: string[];
    /**
     * @generated from protobuf field: repeated string dataset_ids = 12;
     */
    datasetIds: string[];
    /**
     * @generated from protobuf field: string mime_type = 13;
     */
    mimeType: string;
}
/**
 * CaptureInterval specifies the start and end times of the data capture.
 *
 * @generated from protobuf message viam.app.datasync.v1.CaptureInterval
 */
export interface CaptureInterval {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end = 2;
     */
    end?: Timestamp;
}
/**
 * DataCaptureMetadata contains the metadata for data captured by collectors.
 *
 * @generated from protobuf message viam.app.datasync.v1.DataCaptureMetadata
 */
export interface DataCaptureMetadata {
    /**
     * @generated from protobuf field: string component_type = 1;
     */
    componentType: string;
    /**
     * @generated from protobuf field: string component_name = 2;
     */
    componentName: string;
    /**
     * @generated from protobuf field: string method_name = 4;
     */
    methodName: string;
    /**
     * @generated from protobuf field: viam.app.datasync.v1.DataType type = 5;
     */
    type: DataType;
    /**
     * @generated from protobuf field: map<string, google.protobuf.Any> method_parameters = 6;
     */
    methodParameters: {
        [key: string]: Any;
    };
    /**
     * @generated from protobuf field: string file_extension = 7;
     */
    fileExtension: string;
    /**
     * @generated from protobuf field: repeated string tags = 8;
     */
    tags: string[];
    /**
     * @generated from protobuf field: string mime_type = 10;
     */
    mimeType: string;
}
/**
 * DataCaptureUploadMetadata contains the metadata for streaming binary (image + file) data.
 *
 * @generated from protobuf message viam.app.datasync.v1.DataCaptureUploadMetadata
 */
export interface DataCaptureUploadMetadata {
    /**
     * @generated from protobuf field: viam.app.datasync.v1.UploadMetadata upload_metadata = 1;
     */
    uploadMetadata?: UploadMetadata;
    /**
     * @generated from protobuf field: viam.app.datasync.v1.SensorMetadata sensor_metadata = 2;
     */
    sensorMetadata?: SensorMetadata;
}
/**
 * @generated from protobuf enum viam.app.datasync.v1.MimeType
 */
export enum MimeType {
    /**
     * @generated from protobuf enum value: MIME_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MIME_TYPE_IMAGE_JPEG = 1;
     */
    IMAGE_JPEG = 1,
    /**
     * @generated from protobuf enum value: MIME_TYPE_IMAGE_PNG = 2;
     */
    IMAGE_PNG = 2,
    /**
     * @generated from protobuf enum value: MIME_TYPE_APPLICATION_PCD = 3;
     */
    APPLICATION_PCD = 3,
    /**
     * @generated from protobuf enum value: MIME_TYPE_VIDEO_MP4 = 4;
     */
    VIDEO_MP4 = 4
}
/**
 * DataType specifies the type of data uploaded.
 *
 * @generated from protobuf enum viam.app.datasync.v1.DataType
 */
export enum DataType {
    /**
     * @generated from protobuf enum value: DATA_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: DATA_TYPE_BINARY_SENSOR = 1;
     */
    BINARY_SENSOR = 1,
    /**
     * @generated from protobuf enum value: DATA_TYPE_TABULAR_SENSOR = 2;
     */
    TABULAR_SENSOR = 2,
    /**
     * @generated from protobuf enum value: DATA_TYPE_FILE = 3;
     */
    FILE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class DataCaptureUploadRequest$Type extends MessageType<DataCaptureUploadRequest> {
    constructor() {
        super("viam.app.datasync.v1.DataCaptureUploadRequest", [
            { no: 1, name: "metadata", kind: "message", T: () => UploadMetadata },
            { no: 2, name: "sensor_contents", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SensorData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.DataCaptureUploadRequest
 */
export const DataCaptureUploadRequest = new DataCaptureUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataCaptureUploadResponse$Type extends MessageType<DataCaptureUploadResponse> {
    constructor() {
        super("viam.app.datasync.v1.DataCaptureUploadResponse", [
            { no: 1, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.DataCaptureUploadResponse
 */
export const DataCaptureUploadResponse = new DataCaptureUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileUploadRequest$Type extends MessageType<FileUploadRequest> {
    constructor() {
        super("viam.app.datasync.v1.FileUploadRequest", [
            { no: 1, name: "metadata", kind: "message", oneof: "uploadPacket", T: () => UploadMetadata },
            { no: 2, name: "file_contents", kind: "message", oneof: "uploadPacket", T: () => FileData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.FileUploadRequest
 */
export const FileUploadRequest = new FileUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileUploadResponse$Type extends MessageType<FileUploadResponse> {
    constructor() {
        super("viam.app.datasync.v1.FileUploadResponse", [
            { no: 1, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.FileUploadResponse
 */
export const FileUploadResponse = new FileUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamingDataCaptureUploadRequest$Type extends MessageType<StreamingDataCaptureUploadRequest> {
    constructor() {
        super("viam.app.datasync.v1.StreamingDataCaptureUploadRequest", [
            { no: 1, name: "metadata", kind: "message", oneof: "uploadPacket", T: () => DataCaptureUploadMetadata },
            { no: 2, name: "data", kind: "scalar", oneof: "uploadPacket", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.StreamingDataCaptureUploadRequest
 */
export const StreamingDataCaptureUploadRequest = new StreamingDataCaptureUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StreamingDataCaptureUploadResponse$Type extends MessageType<StreamingDataCaptureUploadResponse> {
    constructor() {
        super("viam.app.datasync.v1.StreamingDataCaptureUploadResponse", [
            { no: 1, name: "file_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "binary_data_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.StreamingDataCaptureUploadResponse
 */
export const StreamingDataCaptureUploadResponse = new StreamingDataCaptureUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SensorMetadata$Type extends MessageType<SensorMetadata> {
    constructor() {
        super("viam.app.datasync.v1.SensorMetadata", [
            { no: 1, name: "time_requested", kind: "message", T: () => Timestamp },
            { no: 2, name: "time_received", kind: "message", T: () => Timestamp },
            { no: 3, name: "mime_type", kind: "enum", T: () => ["viam.app.datasync.v1.MimeType", MimeType, "MIME_TYPE_"] },
            { no: 4, name: "annotations", kind: "message", T: () => Annotations }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.SensorMetadata
 */
export const SensorMetadata = new SensorMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SensorData$Type extends MessageType<SensorData> {
    constructor() {
        super("viam.app.datasync.v1.SensorData", [
            { no: 1, name: "metadata", kind: "message", T: () => SensorMetadata },
            { no: 2, name: "struct", kind: "message", oneof: "data", T: () => Struct },
            { no: 3, name: "binary", kind: "scalar", oneof: "data", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.SensorData
 */
export const SensorData = new SensorData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileData$Type extends MessageType<FileData> {
    constructor() {
        super("viam.app.datasync.v1.FileData", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.FileData
 */
export const FileData = new FileData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadMetadata$Type extends MessageType<UploadMetadata> {
    constructor() {
        super("viam.app.datasync.v1.UploadMetadata", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "component_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "type", kind: "enum", T: () => ["viam.app.datasync.v1.DataType", DataType, "DATA_TYPE_"] },
            { no: 8, name: "method_parameters", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Any } },
            { no: 7, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "file_extension", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "file_create_time", kind: "message", T: () => Timestamp },
            { no: 15, name: "file_modify_time", kind: "message", T: () => Timestamp },
            { no: 10, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "dataset_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.UploadMetadata
 */
export const UploadMetadata = new UploadMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CaptureInterval$Type extends MessageType<CaptureInterval> {
    constructor() {
        super("viam.app.datasync.v1.CaptureInterval", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.CaptureInterval
 */
export const CaptureInterval = new CaptureInterval$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataCaptureMetadata$Type extends MessageType<DataCaptureMetadata> {
    constructor() {
        super("viam.app.datasync.v1.DataCaptureMetadata", [
            { no: 1, name: "component_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "component_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "type", kind: "enum", T: () => ["viam.app.datasync.v1.DataType", DataType, "DATA_TYPE_"] },
            { no: 6, name: "method_parameters", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Any } },
            { no: 7, name: "file_extension", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.DataCaptureMetadata
 */
export const DataCaptureMetadata = new DataCaptureMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DataCaptureUploadMetadata$Type extends MessageType<DataCaptureUploadMetadata> {
    constructor() {
        super("viam.app.datasync.v1.DataCaptureUploadMetadata", [
            { no: 1, name: "upload_metadata", kind: "message", T: () => UploadMetadata },
            { no: 2, name: "sensor_metadata", kind: "message", T: () => SensorMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.datasync.v1.DataCaptureUploadMetadata
 */
export const DataCaptureUploadMetadata = new DataCaptureUploadMetadata$Type();
/**
 * @generated ServiceType for protobuf service viam.app.datasync.v1.DataSyncService
 */
export const DataSyncService = new ServiceType("viam.app.datasync.v1.DataSyncService", [
    { name: "DataCaptureUpload", options: { "google.api.http": { post: "/datasync/v1/data_capture_upload" } }, I: DataCaptureUploadRequest, O: DataCaptureUploadResponse },
    { name: "FileUpload", clientStreaming: true, options: { "google.api.http": { post: "/datasync/v1/file_upload" } }, I: FileUploadRequest, O: FileUploadResponse },
    { name: "StreamingDataCaptureUpload", clientStreaming: true, options: { "google.api.http": { post: "/datasync/v1/streaming_data_capture_upload" } }, I: StreamingDataCaptureUploadRequest, O: StreamingDataCaptureUploadResponse }
]);
